import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { CATEGORIES } from "@/mocks/site";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面不存在 - 华丽的外出影视大全",
    description: "你访问的页面不存在，可能已被移动或删除。返回首页继续浏览影视作品与最新动态。",
    keywords: "404,页面不存在,华丽的外出",
  });

  return (
    <SiteLayout>
      <div className="shell flex flex-col items-center py-20 text-center md:py-28">
        <p className="font-heading text-[64px] font-extrabold leading-none tracking-tight text-primary-500 md:text-[96px]">
          404
        </p>
        <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">这一格胶片是空的</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的页面可能已被移动或删除。可以回到首页看看本周焦点，或者从下面的分类重新出发。
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2.5">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line text-base" />
            返回首页
          </Link>
          <Link
            to="/news"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            影视动态
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {CATEGORIES.map((category) => (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className="inline-flex cursor-pointer items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3.5 py-1.5 text-xs font-medium text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className={category.icon} />
              {category.label}
            </Link>
          ))}
        </div>
      </div>
    </SiteLayout>
  );
}